// extracted by mini-css-extract-plugin
export default {"eachCategory":"PriceListEachCategory_eachCategory__9MfG0","categoryWrapper":"PriceListEachCategory_categoryWrapper__ufa+j"};